/**
 * @generated SignedSource<<128291db01705ef18c834651fccdb243>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PipelineRunHeaderCancelBuildMutation$variables = {
  buildLocator: string;
};
export type PipelineRunHeaderCancelBuildMutation$data = {
  readonly cancelBuild: {
    readonly rawId: number | null | undefined;
  } | null | undefined;
};
export type PipelineRunHeaderCancelBuildMutation = {
  response: PipelineRunHeaderCancelBuildMutation$data;
  variables: PipelineRunHeaderCancelBuildMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelineRunHeaderCancelBuildMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "cancelBuild",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelineRunHeaderCancelBuildMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "cancelBuild",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "77c0e8d83c93d5cf0de89556e6ccd3d1",
    "id": null,
    "metadata": {},
    "name": "PipelineRunHeaderCancelBuildMutation",
    "operationKind": "mutation",
    "text": "mutation PipelineRunHeaderCancelBuildMutation(\n  $buildLocator: String!\n) {\n  cancelBuild(buildLocator: $buildLocator, input: {}) {\n    rawId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e16505491caf5dc5a7505f02b0108a18";

export default node;
